import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadRecentCases } from '../../../utils/firebase';
import AlgorithmStats from '../../common/algorithm/AlgorithmStats';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './SlowestAlgorithmsPanel.css';

export default function SlowestAlgorithmsPanel({ mode, title }) {
  const [slowestAlgs, setSlowestAlgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await loadRecentCases(mode);
        setSlowestAlgs(data);
      } catch (error) {
        console.error('Error fetching slow algorithms:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [mode]);

  const handlePracticeNow = () => {
    // We're already on the practice page, so just update the selected algorithms
    if (slowestAlgs.length > 0) {
      const selectedAlgorithms = slowestAlgs.map(alg => alg.id);
      window.location.reload(); // Refresh the page with the new state
      navigate('.', { state: { selectedAlgorithms }, replace: true });
    }
  };

  if (loading) return null;
  if (!slowestAlgs.length) return null;

  return (
    <div className="slowest-algs-panel">
      <div className="panel-header">
        <h3>{title}</h3>
        <button 
          className="expand-button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? (
            <>
              <KeyboardArrowUpIcon /> Hide Details
            </>
          ) : (
            <>
              <KeyboardArrowDownIcon /> Show Details
            </>
          )}
        </button>
      </div>
      <div className="alg-list">
        <button 
          className="practice-now-button"
          onClick={handlePracticeNow}
        >
          Practice These Algorithms
        </button>
        {slowestAlgs.map((alg) => (
          <AlgorithmStats 
            key={alg.id} 
            alg={alg} 
            isExpanded={isExpanded}
          />
        ))}
      </div>
    </div>
  );
} 